import { Injectable } from '@angular/core';
import { UserTypes } from '../enums/user-type.enum';
import { Router, CanLoad, RouterStateSnapshot } from '@angular/router';
import { SecurityService } from '../../shared/utilities/security.service';

@Injectable()
export class StaffAuthGuard implements CanLoad {
  constructor(private securityService: SecurityService, private router: Router) {}

  canActivate(state: RouterStateSnapshot) {
    const token = this.securityService.getToken();
    if (!token) {
      //this.router.navigateByUrl('/auth/login');
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url }});
      return false;
    }
    return true;
  }

  canLoad(): boolean {
    if (this.securityService.isAuthenticated() && this.securityService.getUserType() === UserTypes.staff) {
      return true;
    } else {
      this.router.navigateByUrl('auth/login');
      return false;
    }
  }
}
